import { RegisterFormValues } from 'types/ui';

const initialValues: RegisterFormValues = {
  firstName: '',
  lastName: '',
  prePersonalId: '',
  postPersonalId: '',
  bankAccountClearingNumber: '',
  bankAccountNumber: '',
  monthlyIncome: '',
  monthlyOtherLoans: '',
  monthlyHousingCosts: '',
  monthlyOtherLivingCosts: '',
  numberOfChildrenInHouse: '',
  numberOfAdultsInHouse: '',
  email: '',
  phone: '',
  password: '',
  agreement1: false,
  agreement2: false,
};

export default initialValues;
